// test468
(468 && 0);
